import { IS_PRODUCTION } from '../constants/constants'

declare global {
  interface Window {
    initializeZoho: (args: { widgetCode: string; languageCode: string; countryCode: string; testMode: boolean }) => void
    openZohoChat: (args: { companyName: string; countryName: string }) => void
  }
}

const MAX_RETRIES = 3
const RETRY_DELAY_MS = 1000

const tryInitializeZoho = async ({
  widgetCode,
  customerLanguage,
  countryIsoCode,
  testMode,
  attempt = 1,
}: {
  widgetCode: string
  customerLanguage: string
  countryIsoCode: string
  testMode: boolean
  attempt?: number
}): Promise<void> => {
  try {
    await window.initializeZoho({
      widgetCode,
      languageCode: customerLanguage,
      countryCode: countryIsoCode,
      testMode,
    })
  } catch (error) {
    if (attempt < MAX_RETRIES) {
      const delay = RETRY_DELAY_MS * 2 ** (attempt - 1)
      await new Promise((resolve) => setTimeout(resolve, delay))
      console.log(`initializeICASChat failed: retrying in ${delay}ms, attempt ${attempt} of ${MAX_RETRIES}`, error)
      return await tryInitializeZoho({
        widgetCode,
        customerLanguage,
        countryIsoCode,
        testMode,
        attempt: attempt + 1,
      })
    } else {
      console.error(`initializeICASChat failed: reached maximum retry limit of ${MAX_RETRIES}`, error)
    }
  }
}

export const initializeICASChat = ({
  customerLanguage,
  countryIsoCode,
  testMode = true,
  isICASChatInitialized = false,
}: {
  customerLanguage: string
  countryIsoCode: string
  testMode?: boolean
  isICASChatInitialized?: boolean
}) => {
  if (isICASChatInitialized) {
    return
  }

  const widgetCode = IS_PRODUCTION
    ? 'c74e234b6c4a94b905020bcd1fd0c709771f8ad6d9d485deafa43f863bff06e5'
    : 'a8f1afc834944fe50b5aa15c77945685912129ebed265943b39d8c28c960d82cca798bf0fdc90ee130111e8acb6855c7'

  void tryInitializeZoho({
    widgetCode,
    customerLanguage,
    countryIsoCode,
    testMode,
  })
}

export const openICASChat = ({ customerName, countryName }: { customerName: string; countryName: string }) => {
  try {
    window.openZohoChat({ companyName: customerName, countryName })
  } catch (error) {
    console.error('openICASChat failed with', error)
  }
}
